import { render, staticRenderFns } from "./PlanNotice.vue?vue&type=template&id=fa331338"
import script from "./PlanNotice.vue?vue&type=script&lang=js"
export * from "./PlanNotice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports